var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReports = function SvgReports(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M13.167 3C14.177 3 15 3.785 15 4.75v10.5c0 .965-.822 1.75-1.833 1.75H5.833C4.823 17 4 16.215 4 15.25V7.375h3.667c.507 0 .916-.391.916-.875V3zm-5.5 0v3.5H4zm1.146 6.781v4.813c0 .363.306.656.687.656s.688-.293.688-.656V9.78c0-.363-.307-.656-.688-.656s-.687.293-.687.656m-2.521 1.75v3.063c0 .363.306.656.687.656s.688-.293.688-.656V11.53c0-.363-.307-.656-.688-.656s-.687.293-.687.656m5.041 1.75v1.313c0 .363.307.656.688.656s.687-.293.687-.656V13.28c0-.363-.306-.656-.687-.656s-.688.293-.688.656"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReports);
export default ForwardRef;